import { render, staticRenderFns } from "./CncCheckbox.vue?vue&type=template&id=0127d6e3"
import script from "./CncCheckbox.vue?vue&type=script&lang=js"
export * from "./CncCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CncCheckbox.vue?vue&type=style&index=0&id=0127d6e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports